import React, { useContext, useEffect } from 'react'
import {HeadTableLeads, RowLeadsLiderforAssign } from "../../ui-components";
import LeadsContext from '../../context/leads';

function ForAssignLeader({onToggleTab,setAssignLead, order}) {
  const {LeadsAsign,models, Subs,toggle} = useContext(LeadsContext)
  
  useEffect(()=>{
    LeadsAsign(0,1, order, "register");
    Subs();
  },[order, toggle])

  return (
    <div className="overflow-x-scroll py-2">
   <HeadTableLeads type="forAssign" width={"1945px"} overrides={{ 
    "Asignaci\u00F3n":{
      display:'block',
      children:"Contact Center"
    },
    "Fase": { 
      children:"Fecha de Asignación",
      display: "block"
    },
    Sucursal: { display: "block" },
    "Acci\u00F3n": { display: "block" },
    "Asesor Conekta": { display: "none" },
    }}/>
   {models?.map((lead, index) => (
    index % 2 == 0 ?
    <RowLeadsLiderforAssign key={lead.id} leads={lead}overrides={{ 
      Button:{
        onClick: () =>{
          onToggleTab(7)
          setAssignLead(lead)
        }
      }
    }}/> :
    <RowLeadsLiderforAssign key={lead.id} leads={lead} overrides={{ 
    "Frame 20797":{backgroundColor: "#ffffff"},
    Button:{
      onClick: () =>{
        onToggleTab(7)
        setAssignLead(lead)
      }
    }
  }}/>
   ))}
  </div>

  )
}

export default ForAssignLeader